import React from 'react'

function Wrapper({title, children, className, isReadOnly}) {
  return (
    <div className={`${!isReadOnly && 'px-3 mx-5'} ${className}`} style={{paddingBottom: "4rem"}}>
      {title && <h2 className='px-3'>{title} </h2>}
      <div className={`${!isReadOnly && 'p-3'}`}>{children}</div>
    </div>
  )
}

export default Wrapper